// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PayPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/pay_period/{id}
 *
 * Returns the list of created salary expenses after completing payment.
 *
 * @see Payroll::pay_period() controller
 * @see Payroll_service::completePayment()
 */
import type { Payroll_PayPeriodSalaryExpenseRow } from './Payroll_PayPeriodSalaryExpenseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PayPeriodResponseDados {
items: Payroll_PayPeriodSalaryExpenseRow[]
}

export type Payroll_PayPeriodResponse = ApiResponse<Payroll_PayPeriodResponseDados>;

registerResponseContract('Payroll_PayPeriodResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      execution_id: { type: 'number',  required: true },
      expense_id:   { type: 'number',  required: true },
      user_id:      { type: 'string',  required: true },
      amount:       { type: 'string',  required: true },
    },
  },
})
